import api from "./client";

// Turn-taking config: end-of-turn silence / interruption thresholds, split by
// scope (normal vs stress-test calls). Editable at runtime — see AdminTurnTaking.
export const turnTakingAPI = {
  get: () => api.get("/admin/turn_taking_config").then((r) => r.data),
  update: (scope, body) => api.patch(`/admin/turn_taking_config/${scope}`, body).then((r) => r.data),
};
